<template>  
  <b-button 
    size="sm" 
    variant="warning" 
    v-b-tooltip.hover 
    :title="showToolTip ? toolTip : ''" 
    @click="click"
  >
    <i :class="state ? 'fa fa-arrow-up' : 'fa fa-arrow-down'"></i>
  </b-button>
</template>

<script>

export default ({
  name: "button-additional-info",
  data: () => {
    return {
      state: false
    }
  },
  computed: {
    showToolTip() {
      return this.$store.state.userSettings.showTooltips;
    },
    toolTip() {
      return this.state ? 'Скрыть дополнительные сведения' : 'Показать дополнительные сведения'
    }
  },
  methods: {
    click() {
      this.state = !this.state;
      this.$emit('click', this.state);
    }
  }
})
</script>
